import store from '../../../store'

// get default data from config file
import configData from '../../../config'

const dataSearchDefault = configData().params.search.default

const resetPageStart = () => {
  store.commit('SET_NEW_START', dataSearchDefault.pageStart)
}

const resetRows = () => {
  store.commit('SET_ROWS_NUM', dataSearchDefault.itemsPerPage)
}

const resetSorting = () => {
  store.commit('SET_NEW_SORTING', dataSearchDefault.sortOption)
}

const setPageStart = (n) => {
  store.commit('SET_NEW_START', n)
}

const setRowsNum = (n) => {
  store.commit('SET_ROWS_NUM', n)
}

const setNewSorting = (n) => {
  store.commit('SET_NEW_SORTING', n)
}

const setCurrentPage = (n) => {
  store.commit('SET_CURRENT_PAGE', n);
}

const setSearchParams = (params) => {
  store.commit('SET_SEARCH_PARAMS', params)
}

const setNewSearchParamsKey = (key) => {
  store.commit('SET_NEW_SEARCH_PARAMS_KEY', key)
}

const setNewSearchParamsParam = (param) => {
  store.commit('SET_NEW_SEARCH_PARAMS_PARAM', param)
}

//actions

const loadSearchResults = () => {
  store.dispatch('LOAD_SEARCH_RESULTS')
}

const loadSearchResultsWithDataPreload = () => {
  store.dispatch('LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD')
}

const loadSearchResultsWithDataPreloadAlt = () => {
  store.dispatch('LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD_ALT')
}

const loadDateRanges = () => {
  store.dispatch('LOAD_DATE_RANGES')
}

export {
  resetPageStart,
  resetRows,
  resetSorting,
  setPageStart,
  setRowsNum,
  setNewSorting,
  setCurrentPage,
  setSearchParams,
  setNewSearchParamsKey,
  setNewSearchParamsParam,
  loadSearchResults,
  loadSearchResultsWithDataPreload,
  loadSearchResultsWithDataPreloadAlt,
  loadDateRanges
}



// WEBPACK FOOTER //
// ./src/scripts/modules/store/searchStore-setters.js